// Maintenance category to worker specialization mapping
export const MAINTENANCE_CATEGORIES = [
    { id: "electrical", name: "Electrical", specializations: ["Electrical"] },
    { id: "plumbing", name: "Plumbing", specializations: ["Plumbing"] },
    { id: "hvac", name: "HVAC", specializations: ["HVAC"] },
    { id: "cleaning", name: "Cleaning", specializations: ["Cleaning"] },
    { id: "it", name: "IT Support", specializations: ["IT Support"] },
    { id: "general", name: "General Maintenance", specializations: ["General Maintenance"] },
    { id: "safety", name: "Safety & Security", specializations: ["Safety & Security"] },
    { id: "furniture", name: "Furniture & Fixtures", specializations: ["Carpentry", "General Maintenance"] },
    { id: "carpentry", name: "Carpentry", specializations: ["Carpentry"] },
    { id: "painting", name: "Painting", specializations: ["Painting"] },
    { id: "equipment", name: "Equipment Repair", specializations: ["Equipment Repair", "General Maintenance"] }
];

export const WORKER_SPECIALIZATIONS = [
    "Electrical",
    "Plumbing",
    "HVAC",
    "Carpentry",
    "Painting",
    "Cleaning",
    "IT Support",
    "General Maintenance",
    "Equipment Repair",
    "Safety & Security"
];

// Get required specializations for a maintenance category
export const getRequiredSpecializations = (category) => {
    const categoryConfig = MAINTENANCE_CATEGORIES.find(cat => cat.id === category);
    return categoryConfig ? categoryConfig.specializations : ["General Maintenance"];
};

// Check if worker can handle a maintenance category
export const canWorkerHandleCategory = (workerSpecializations, category) => {
    const requiredSpecs = getRequiredSpecializations(category);
    return requiredSpecs.some(spec => workerSpecializations.includes(spec));
};
